export default __webpack_public_path__ + "static/media/no-active-campaign.6a0b64b3.svg";